// src/components/modals/InactivityLogoutModal.tsx
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

interface Props {
  onLogout: () => void;
}

const InactivityLogoutModal: React.FC<Props> = ({ onLogout }) => {
  const [secondsLeft, setSecondsLeft] = useState(30);
  const navigate = useNavigate();

  useEffect(() => {
    const countdown = setInterval(() => {
      setSecondsLeft((s) => s - 1);
    }, 1000);

    const timeout = setTimeout(() => {
      onLogout();
    }, 30000);

    return () => {
      clearInterval(countdown);
      clearTimeout(timeout);
    };
  }, [onLogout]);

  return (
    <div className="inactivity-modal-overlay">
      <div className="inactivity-modal">
        <h2>Are you still there?</h2>
        <p>
          You will be logged out in {secondsLeft} seconds due to inactivity.
        </p>
        <button onClick={() => navigate(0)} className="inactivity-button">
          I'm still here
        </button>
      </div>
    </div>
  );
};

export default InactivityLogoutModal;
